module.exports = __webpack_public_path__ + "img/twitter.24b0fea3.png";